import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface Tender {
  id: number;
  country: string;
  sector: string;
  date: string;
  title: string;
}
const initialTenders: Tender[] = [{
  id: 1,
  country: 'Maroc',
  sector: 'Énergie',
  date: "Aujourd'hui",
  title: 'Installation de panneaux solaires'
}, {
  id: 2,
  country: 'Sénégal',
  sector: 'Infrastructure',
  date: "Aujourd'hui",
  title: 'Construction de routes rurales'
}, {
  id: 3,
  country: "Côte d'Ivoire",
  sector: 'Santé',
  date: "Aujourd'hui",
  title: 'Équipement médical pour hôpitaux'
}, {
  id: 4,
  country: 'Tunisie',
  sector: 'Éducation',
  date: 'Hier',
  title: 'Fourniture de matériel informatique'
}, {
  id: 5,
  country: 'Kenya',
  sector: 'Agriculture',
  date: 'Hier',
  title: "Systèmes d'irrigation innovants"
}];
const sectors = ['Énergie', 'Infrastructure', 'Santé', 'Éducation', 'Agriculture', 'Technologie', 'Transport', 'Eau', 'Télécommunications'];
const countries = ['Maroc', 'Sénégal', "Côte d'Ivoire", 'Tunisie', 'Kenya', 'Nigeria', 'Ghana', 'Égypte', 'Afrique du Sud', 'Cameroun'];
export function LiveTenderFeed() {
  const [tenders, setTenders] = useState<Tender[]>(initialTenders);
  useEffect(() => {
    const interval = setInterval(() => {
      const newTender: Tender = {
        id: Date.now(),
        country: countries[Math.floor(Math.random() * countries.length)],
        sector: sectors[Math.floor(Math.random() * sectors.length)],
        date: "À l'instant",
        title: `Nouvel appel d'offres en ${sectors[Math.floor(Math.random() * sectors.length)].toLowerCase()}`
      };
      setTenders(prev => [newTender, ...prev.slice(0, 4)]);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-white rounded-lg shadow-lg p-4 h-full overflow-hidden" data-id="element-944">
      <h3 className="text-lg font-semibold text-blue-900 mb-4 flex items-center" data-id="element-945">
        <span className="relative mr-2" data-id="element-946">
          <span className="h-2 w-2 bg-green-500 rounded-full" data-id="element-947"></span>
          <span className="absolute top-0 left-0 h-2 w-2 bg-green-500 rounded-full animate-ping" data-id="element-948"></span>
        </span>
        Flux d'appels d'offres en temps réel
      </h3>
      <div className="space-y-4 overflow-hidden" data-id="element-949">
        <AnimatePresence data-id="element-950">
          {tenders.map(tender => <motion.div key={tender.id} className="bg-gray-50 rounded p-3 border-l-4 border-blue-900" initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-951">
              <div className="flex justify-between" data-id="element-952">
                <span className="text-sm font-medium text-blue-900" data-id="element-953">
                  {tender.country}
                </span>
                <span className="text-xs text-gray-500" data-id="element-954">{tender.date}</span>
              </div>
              <p className="text-sm mt-1" data-id="element-955">{tender.title}</p>
              <div className="mt-2" data-id="element-956">
                <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded" data-id="element-957">
                  {tender.sector}
                </span>
              </div>
            </motion.div>)}
        </AnimatePresence>
      </div>
    </div>;
}